import React from 'react';
import { Check, X } from 'lucide-react';
import { motion } from 'framer-motion';
import { PackSelector } from './PackSelector';
const comparisonTable = [{
  feature: 'Precio',
  inicial: '$19.990',
  pro: '$24.990',
  full: '$29.990'
}, {
  feature: 'Las 8 guías',
  inicial: true,
  pro: true,
  full: true
}, {
  feature: 'Bono 1 — 30 preguntas',
  inicial: false,
  pro: true,
  full: true
}, {
  feature: 'Bono 2 — Calculadora',
  inicial: false,
  pro: true,
  full: true
}, {
  feature: 'Bono 3 — 30 textos IG',
  inicial: false,
  pro: false,
  full: true
}, {
  feature: 'Bono 4 — Directorio',
  inicial: false,
  pro: false,
  full: true
}, {
  feature: 'Bono 5 — Guión DM',
  inicial: false,
  pro: false,
  full: true
}, {
  feature: 'Bono 6 — Checklist',
  inicial: false,
  pro: false,
  full: true
}, {
  feature: 'Bono 7 — Shooting',
  inicial: false,
  pro: false,
  full: true
}, {
  feature: 'Bono 8 — Calendario',
  inicial: false,
  pro: false,
  full: true
}];
export function Pricing() {
  return <section id="pricing" className="w-full py-10 sm:py-20" data-id="element-183">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-184">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-center mb-8 sm:mb-12" data-id="element-185">
          <h2 className="font-display text-2xl sm:text-4xl lg:text-5xl font-bold text-white mb-3 sm:mb-4" data-id="element-186">
            Elegí tu MEGAPACK EMPRENDEDORA DE MODA
          </h2>
          <p className="text-sm sm:text-base text-violet-100/70" data-id="element-187">
            Las 3 opciones incluyen las 8 guías completas. Los bonos varían
            según el pack.
          </p>
        </motion.div>

        <div className="mb-10 sm:mb-16" data-id="element-188">
          <PackSelector data-id="element-189" />
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="bg-violet-rich/30 border border-gold/20 rounded-xl p-3 sm:p-8" data-id="element-190">
          <h3 className="font-display text-xl sm:text-2xl font-bold text-white text-center mb-6 sm:mb-8" data-id="element-191">
            TABLA COMPARATIVA
          </h3>
          <table className="w-full table-fixed text-[10px] sm:text-sm" data-id="element-192">
            <thead data-id="element-193">
              <tr className="border-b border-gold/20" data-id="element-194">
                <th className="text-left py-2 px-1 sm:px-3 text-violet-100/70 w-[34%]" data-id="element-195"></th>
                <th className="text-center py-2 px-1 sm:px-3 text-gold w-[22%]" data-id="element-196">
                  🟡 INICIAL
                </th>
                <th className="text-center py-2 px-1 sm:px-3 text-blue-400 w-[22%]" data-id="element-197">
                  🔵 PRO ⭐
                </th>
                <th className="text-center py-2 px-1 sm:px-3 text-gold w-[22%]" data-id="element-198">
                  🏆 FULL
                </th>
              </tr>
            </thead>
            <tbody data-id="element-199">
              {comparisonTable.map((row, index) => <tr key={index} className="border-b border-gold/10 hover:bg-violet-deep/30 transition-colors" data-id="element-200">
                  <td className="py-2 px-1 sm:px-3 text-violet-100/90 leading-snug" data-id="element-201">
                    {row.feature}
                  </td>
                  <td className="text-center py-2 px-1 sm:px-3" data-id="element-202">
                    {typeof row.inicial === 'boolean' ? row.inicial ? <Check className="w-3 h-3 sm:w-5 sm:h-5 text-green mx-auto" data-id="element-203" /> : <X className="w-3 h-3 sm:w-5 sm:h-5 text-red-400/60 mx-auto" data-id="element-204" /> : <span className="text-violet-100/90" data-id="element-205">{row.inicial}</span>}
                  </td>
                  <td className="text-center py-2 px-1 sm:px-3" data-id="element-206">
                    {typeof row.pro === 'boolean' ? row.pro ? <Check className="w-3 h-3 sm:w-5 sm:h-5 text-green mx-auto" data-id="element-207" /> : <X className="w-3 h-3 sm:w-5 sm:h-5 text-red-400/60 mx-auto" data-id="element-208" /> : <span className="text-violet-100/90" data-id="element-209">{row.pro}</span>}
                  </td>
                  <td className="text-center py-2 px-1 sm:px-3" data-id="element-210">
                    {typeof row.full === 'boolean' ? row.full ? <Check className="w-3 h-3 sm:w-5 sm:h-5 text-green mx-auto" data-id="element-211" /> : <X className="w-3 h-3 sm:w-5 sm:h-5 text-red-400/60 mx-auto" data-id="element-212" /> : <span className="text-violet-100/90" data-id="element-213">{row.full}</span>}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </motion.div>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.3
      }} className="text-center text-violet-100/60 text-[10px] sm:text-sm mt-6 sm:mt-8 flex flex-wrap justify-center gap-x-2 gap-y-1" data-id="element-214">
          <span data-id="element-215">Pago seguro</span>
          <span className="hidden sm:inline" data-id="element-216">·</span>
          <span data-id="element-217">Acceso en 5 min</span>
          <span className="hidden sm:inline" data-id="element-218">·</span>
          <span data-id="element-219">Garantía 7 días</span>
          <span className="hidden sm:inline" data-id="element-220">·</span>
          <span data-id="element-221">Mercado Pago</span>
        </motion.p>
      </div>
    </section>;
}